import ADMIN_ROUTES from 'config/nav/admin/routes';

const {
  ROOT: HOME,
  RETURN_MANAGEMENT,
  SHIPPING,
  CUSTOMER_PORTAL
} = ADMIN_ROUTES.CONFIGURE_RR;

export const ROUTES = {
  HOME,

  RETURN_MANAGEMENT,
  REFUND_METHODS: `${RETURN_MANAGEMENT}/refund-methods`,
  EXCHANGES: `${RETURN_MANAGEMENT}/exchanges`,
  PURCHASES: `${RETURN_MANAGEMENT}/purchases`,
  AUTOMATION_RULES: `${RETURN_MANAGEMENT}/automation-rules`,
  DEDUCTIONS: `${RETURN_MANAGEMENT}/deductions`,
  FEES_AND_INCENTIVES: `${RETURN_MANAGEMENT}/fees-and-incentives`,
  REQUEST_REASONS: `${RETURN_MANAGEMENT}/request-reasons`,
  ADDITIONAL_FEATURES: `${RETURN_MANAGEMENT}/additional-features`,
  SHOPPER_GROUPS: `${RETURN_MANAGEMENT}/shopper-groups`,
  RETURN_WINDOW: `${RETURN_MANAGEMENT}/return-window`,
  PROMO_MANAGEMENT: `${RETURN_MANAGEMENT}/promo-management`,
  EMAIL_ALERTS: `${RETURN_MANAGEMENT}/email-alerts`,
  TAG_BASED_RETURN_RULES: `${RETURN_MANAGEMENT}/tag-based-return-rules`,
  DISPOSITION: `${RETURN_MANAGEMENT}/disposition`,

  SHIPPING,
  SHIPPING_METHODS: `${SHIPPING}/shipping-methods`,
  RETURN_LOCATIONS: `${SHIPPING}/return-locations`,
  ZONES: `${SHIPPING}/service-zones`,
  LANES: `${SHIPPING}/service-lanes`,
  PACKAGE_DIMENSIONS: `${SHIPPING}/package-dimensions`,
  CARRIERS: `${SHIPPING}/carriers`,
  CARRIER_CONFIGURATION: `${SHIPPING}/carrier-config`,
  CONFIGURATION_TESTS: `${SHIPPING}/configuration-tests`,
  AGGREGATORS: `${SHIPPING}/aggregators`,

  CUSTOMER_PORTAL,
  THEME: `${CUSTOMER_PORTAL}/theme`,
  LOGIN_PAGE: `${CUSTOMER_PORTAL}/login-page`,
  BRANDED_THEME: `${CUSTOMER_PORTAL}/branded-theme`,
  TRACKING_PAGE: `${CUSTOMER_PORTAL}/tracking-page`,
  EMAIL_TEMPLATES: `${CUSTOMER_PORTAL}/email-communications`,
  CUSTOMER_CARE: `${CUSTOMER_PORTAL}/customer-care`,
  POLICY_POPUP: `${CUSTOMER_PORTAL}/custom-popup`,
  SERVICE_REQUEST_PREFIX: `${CUSTOMER_PORTAL}/service-request-prefix`
};
